import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { minutesToText } from 'modules/core/lib/duration'
import i18n from 'modules/core/lib/i18n'

import { ActionFrom } from 'modules/attendance/store/models/Shift'

export interface CheckClockOutProps {
  estimatedClockOutTime?: moment.Moment
  actualWorkedMinutes?: number
  from?: string
  forgotClockOut?: boolean
}

interface Props {
  workedDurationToday: number
  maxMinutesPerDay: number
  onClose: () => void
  onConfirm: ({
    estimatedClockOutTime,
    actualWorkedMinutes,
    from,
    forgotClockOut,
  }: CheckClockOutProps) => void
}

const ClockOutReminderModal = ({
  workedDurationToday,
  maxMinutesPerDay,
  onClose,
  onConfirm,
}: Props) => {
  const estimation = minutesToText(maxMinutesPerDay)
  const duration = minutesToText(workedDurationToday)

  return (
    <Modal
      illustration="clock-app"
      title={i18n.t('clock_in.clock_out_reminder.title')}
      description={i18n.t('clock_in.clock_out_reminder.body_text', { estimation, duration })}
      onClose={onClose}
      footer={
        <>
          <Button
            onClick={() =>
              onConfirm({
                actualWorkedMinutes: workedDurationToday,
                from: ActionFrom.FORGOT_CLOCK_OUT_MODAL,
              })
            }
            type="secondary"
          >
            {i18n.t('clock_in.clock_out_reminder.confirm_tracked')}
          </Button>
          <Button
            onClick={() =>
              onConfirm({
                actualWorkedMinutes: workedDurationToday,
                from: ActionFrom.FORGOT_CLOCK_OUT_MODAL,
                forgotClockOut: true,
              })
            }
          >
            {i18n.t('clock_in.clock_out_reminder.confirm_estimated')}
          </Button>
        </>
      }
    />
  )
}

export default observer(ClockOutReminderModal)
